<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
  <div class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border" [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': source !== 'modal'
          }">
    <form [formGroup]="attachmentForm" (ngSubmit)="onSubmit()">
      <h1 *ngIf="source !== 'modal'" class="heading">
        {{attachmentId ? 'Edit' : 'Add'}}
      </h1>
      <hr *ngIf="source !== 'modal'" class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="grid gap-4 sm:grid-cols-2">
        <div class="space-y-1">
          <label class="subheading">
            Documents <span class="text-red-600">*</span>
          </label>
          <div>
            <div>
              <select formControlName="documentType" (change)="onChangeDocument()">
                <option value=""> Select Document Type</option>
                <option *ngFor="let document of documentTypes" value="{{document}}" [disabled]="document !== 'other' && existingDocumentTypes.includes(document)">
                  {{document | titlecase}} {{document !== 'other' && existingDocumentTypes.includes(document) ? '(Already Uploaded)' : ''}}
                </option>
              </select>
            </div>
            <div *ngIf="submitted && form.documentType.errors">
              <p *ngIf="form.documentType.errors.required" class="pt-1 text-red-600 text-xs">
                Document Type is required
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="form.documentType.value === 'other'" class="space-y-1">
          <label class="subheading">
            Title <span class="text-red-600">*</span>
          </label>
          <div>
            <div>
              <input formControlName="title" type="text" />
            </div>
            <div *ngIf="submitted && form.title.errors">
              <p *ngIf="form.title.errors.required" class="pt-1 text-red-600 text-xs">
                Title is required
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="grid gap-4 sm:grid-cols-2 mt-4">
        <div class="space-y-1">
          <!-- <label for="role-type" class="block text-sm font-medium text-main-secondary">Document <span class="text-red-600">*</span></label> -->
          <div class="mt-1">
            <div class="flex justify-center rounded-md border-2 border-dashed border-gray-300 px-6 pt-5 pb-6">
              <div class="space-y-1 text-center">
                <svg *ngIf="selectedFile === null" class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor"
                  fill="none" viewBox="0 0 48 48" aria-hidden="true">
                  <path
                    d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div class="flex text-sm text-gray-600">
                  <label for="customFile"
                    class="relative cursor-pointer rounded-md bg-white font-medium text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:text-indigo-500">
                    <span *ngIf="selectedFile === null">Upload a file</span>
                    <!-- <p *ngIf="selectedFile === null" class="text-xs text-gray-500">
                                  Upload .txt file
                                </p> -->
                    <input type="file" #fileInput (change)="onFileSelection($event)" id="customFile" name="file-upload"
                      class="sr-only" accept=".pdf,application/pdf" />
                    <label *ngIf="selectedFile !== null" for="customFile">{{selectedFile.name}}</label>
                  </label>
                  <div>
                    <button *ngIf="selectedFile" (click)="deleteFile(fileInput)"
                      class="p-1 btn btn-danger rounded-full -top-2.5 -right-2.5 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="size-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-2 text-red-600 text-xs" *ngIf="selectedFile === null && submitted">
            <p class="mt-2 text-red-600 text-xs">
              Document is required
            </p>
          </div>
          <div class="mt-2 text-xs text-main-danger">
            <div>
              Please upload the file in PDF format.
            </div>
          </div>
        </div>
      </section>
      <div class="text-xs text-gray-500">
        <a *ngIf="attachmentId && selectedFile == null" href="{{form.documentUrl.value}}" target="_blank"
          class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600 ng-star-inserted"> 
          {{form.documentUrl.value}}
        </a>
      </div>
      <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="flex justify-end gap-4">
        <button type="submit" class="btn btn-secondary">
          {{attachmentId ? 'Update' : 'Create'}}
        </button>
      </section>
    </form>
  </div>
</section>